var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:proximity-sensor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 10H10V20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10ZM46.6667 10H40C40 17.9565 36.8393 25.5871 31.2132 31.2132C25.5871 36.8393 17.9565 40 10 40V46.6667C30.2667 46.6667 46.6667 30.2333 46.6667 10ZM33.3333 10H26.6667C26.6667 14.4203 24.9107 18.6595 21.7851 21.7851C18.6595 24.9107 14.4203 26.6667 10 26.6667V33.3333C16.1884 33.3333 22.1233 30.875 26.4992 26.4992C30.875 22.1233 33.3333 16.1884 33.3333 10ZM33.3333 70H40C40 62.0435 43.1607 54.4129 48.7868 48.7868C54.4129 43.1607 62.0435 40 70 40V33.3333C60.2754 33.3333 50.9491 37.1964 44.0728 44.0728C37.1964 50.9491 33.3333 60.2754 33.3333 70ZM60 70H70V60C67.3478 60 64.8043 61.0536 62.9289 62.9289C61.0536 64.8043 60 67.3478 60 70ZM46.6667 70H53.3333C53.3333 65.5797 55.0893 61.3405 58.2149 58.2149C61.3405 55.0893 65.5797 53.3333 70 53.3333V46.6667C63.8116 46.6667 57.8767 49.125 53.5008 53.5008C49.125 57.8767 46.6667 63.8116 46.6667 70Z",
    fill: "#64B3E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSensor);
export default __webpack_public_path__ + "static/media/home-sensor.e0540d8c80f9e4894cc01a340960a8f8.svg";
export { ForwardRef as ReactComponent };